"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.endHourOfWorkDay = exports.holidays = void 0;
var business_time_1 = __importDefault(require("./business-time"));
var moment_range_1 = require("moment-range");
require("moment/locale/fr");
require("./tz-protected");
require("./is-between-or-is-after");
var holidays_1 = require("./holidays");
var holidays_2 = require("./holidays");
Object.defineProperty(exports, "holidays", { enumerable: true, get: function () { return holidays_2.holidays; } });
var isServer = typeof window === 'undefined';
// Note: As stated in https://momentjs.com/timezone/docs/#/using-timezones/default-timezone/
//
// By default, moment objects are created in the local time zone.
// Local time zone - it's a time zone which is set in a browser or on your node.js server.
//
// To change the default time zone, use moment.tz.setDefault with a valid time zone.
if (isServer) {
    business_time_1.default.tz.setDefault('Europe/Paris');
}
exports.endHourOfWorkDay = 19;
// This locale is used to estimate when MTs are available. So it has no hollidays and Sunday is a working day.
// No BRs will be sent outside those working times.
business_time_1.default.defineLocale('ambler-mt', {
    parentLocale: 'fr',
    workinghours: {
        0: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
        1: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
        2: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
        3: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
        4: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
        5: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
        6: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
    },
});
// This locale is used to estimate when the TC will be available.
business_time_1.default.locale('ambler-fr', {
    parentLocale: 'fr',
    workinghours: {
        0: null,
        1: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
        2: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
        3: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
        4: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
        5: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
        6: ['08:00:00', "".concat(exports.endHourOfWorkDay, ":00:00")],
    },
    holidays: holidays_1.holidays,
});
var extended = (0, moment_range_1.extendMoment)(business_time_1.default);
exports.default = extended;
//# sourceMappingURL=index.js.map